import { useState, useEffect } from 'react';
import { baseUrl } from '../../../config';

// ── Debounce hook ─────────────────────────────────────────────────────────────
export function useDebounce(v, d) {
  const [deb, setDeb] = useState(v);
  useEffect(() => { const t = setTimeout(() => setDeb(v), d); return () => clearTimeout(t); }, [v, d]);
  return deb;
}

// ── Mobile breakpoint hook ────────────────────────────────────────────────────
export function useMobile() {
  const [mobile, setMobile] = useState(window.innerWidth < 640);
  useEffect(() => {
    const handler = () => setMobile(window.innerWidth < 640);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);
  return mobile;
}

// ── Fetch receipt image with auth header → blob URL ───────────────────────────
export function useReceiptBlob(payment, open) {
  const [blobUrl,  setBlobUrl]  = useState(null);
  const [loading,  setLoading]  = useState(false);
  const [error,    setError]    = useState(false);

  useEffect(() => {
    if (!open || !payment) { setBlobUrl(null); setError(false); return; }
    let revoke;
    setLoading(true); setBlobUrl(null); setError(false);
    const token = localStorage.getItem('memberToken');
    fetch(`${baseUrl}/member/receipt/${payment.id}`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => { if (!r.ok) throw new Error('not ok'); return r.blob(); })
      .then(blob => {
        const url = URL.createObjectURL(blob);
        revoke = url;
        setBlobUrl(url);
      })
      .catch(() => setError(true))
      .finally(() => setLoading(false));
    return () => { if (revoke) URL.revokeObjectURL(revoke); };
  }, [open, payment?.id]); // eslint-disable-line

  return { blobUrl, loading, error };
}
